// extracted by mini-css-extract-plugin
export default {"icon":"KiCheckbox_icon__AuY4A","container":"KiCheckbox_container__FxLut"};